export default __webpack_public_path__ + "static/media/sjjl.3b0b4dcb.png";